import React, {useState} from "react";
import './McDonaldsRedemption.scss';
import Strings from "../../../config/Strings";
import {Form, Spinner} from "react-bootstrap";
import {TigerButton} from "../../../global/tiger-button/TigerButton";
import {GetFilteredResources, GetUnauthorizedResources} from "../../../api/SpineClient";
import GlobalConstants from "../../../config/GlobalConstants";
import {InfoModal} from "../../../global/ConfirmationModal";
import {useHistory, useLocation} from "react-router";

export default function McDonaldsRedemptionTicketValidation() {

    const queryParams = new URLSearchParams(window.location.search);

    const [form, setForm] = useState({voucherCode: queryParams.get("key"), code: null});
    const [formError, setFormError] = useState({voucherCode: null});
    const [loading, setLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorText, setErrorText] = useState(null);
    const history = useHistory();
    const location = useLocation();

    document.title = "Dein McDonalds Vorteilscode";

    if (location !== undefined && location.hash !== "") {
        const element = document.getElementById(location.hash);
        if (element) {
            element.scrollIntoView({behavior: "smooth", block: "start"});
        }
    }

    //Submitting
    const validateTicket = async e => {
        setLoading(true);
        e.preventDefault();

        let voucherCode = form.voucherCode;
        let code = voucherCode.substring(0, voucherCode.indexOf("-"));
        let pin = voucherCode.substring(voucherCode.indexOf("-") + 1, voucherCode.length);

        //First check if it's a mcdonalds coupon
        let minimalCoupon = await GetUnauthorizedResources('api/purchases/coupons/search/minimal-by-code', {code: code});
        setLoading(false);
        if (minimalCoupon.error) {
            if (minimalCoupon.result === 404) {
                setFormError({
                    ...formError,
                    voucherCode:  Strings.MCDONALDS_REDEMPTION_CODE_ERROR_1
                });
            } else {
                setErrorText(Strings.MCDONALDS_REDEMPTION_UNKNOWN_ERROR);
                setShowError(true);
            }
            return;

        } else {
            if (minimalCoupon.result.couponType !== "MCDONALDS") {
                setFormError({
                    ...formError,
                    voucherCode:  Strings.MCDONALDS_REDEMPTION_CODE_ERROR_1
                });
                return;
            }

        }

        let validation = await GetFilteredResources('api/purchases/coupons/validate', {code: code, pin: pin});

        setLoading(false);

        if (validation.error) {
            setErrorText(Strings.MCDONALDS_REDEMPTION_UNKNOWN_ERROR)
            setShowError(true);
        } else {
            await handleValidationResult(validation.result, code, pin);
        }
    }

    const handleValidationResult = async (result, code, pin) => {
        let valid = result.valid;
        const resultCode = result.code;
        let alreadyUsed = false;

        //Validate the response from the purchase service
        switch (resultCode) {
            case 1:
                //Coupon does not exist
                setFormError({
                    ...formError,
                    voucherCode:  Strings.MCDONALDS_REDEMPTION_CODE_ERROR_1
                });
                break;
            case 2:
                //Coupon temporary disabled for X Minutes
                setFormError({
                    ...formError,
                    voucherCode: Strings.MCDONALDS_REDEMPTION_CODE_ERROR_2.replace("{0}", result.value)
                });
                break;
            case 3:
                //Wrong PIN provided for last time -> Coupon is now disabled
                setFormError({
                    ...formError,
                    voucherCode: Strings.MCDONALDS_REDEMPTION_CODE_ERROR_3
                });
                break;
            case 4:
                //Wrong PIN provided -> X retries left
                setFormError({
                    ...formError,
                    voucherCode: Strings.MCDONALDS_REDEMPTION_PIN_ERROR_1.replace("{0}", result.value)
                });
                break;
            case 5:
                //Coupon has been already used
                alreadyUsed = true;
                break;
            default:
                //Coupon has not been used yet
                valid = true;
                break;
        }

        //In case of an already used ticket show error
        if (alreadyUsed) {
            setFormError({
                ...formError,
                voucherCode:  Strings.MCDONALDS_REDEMPTION_CODE_ERROR_ALREADY_USED
            });
        } else if (valid) {
            //It's not used -> It can be redeemed (proceed to next step)
            sessionStorage.setItem('ls.mcdonalds', JSON.stringify({code: code, pin: pin, voucherCode: form.voucherCode}));
            history.push("/" + GlobalConstants.APP_PATH + "mcdonalds/authenticate#mcdonalds-authentication-register")
        }
    }

    const updateForm = (field, value) => {
        setForm({
            ...form,
            [field]: value.toUpperCase()
        });
        setFormError({
            ...formError,
            [field]: null
        });
    }

    //Rendering
    return (
        <div className="mcdonalds-container">
            <div className="mcdonalds-header-overlay">
                <div>
                    <img src={"https://cdn.tigerbooks.de/promotion/mcdonalds/header.png"}
                         alt={"header"}/>
                </div>
            </div>

            <div className={"mcdonalds-description-text"}>
                <h1 style={{color:"#a71680", fontSize:"1.5rem"}}>Der Hörspaß kann beginnen!</h1>
                <p><b>Mit tigertones, dem Audio-Streamingdienst für Hörspiele, Musik, Wissen & mehr von tigermedia, findet
                    jedes Kind garantiert, was es hören möchte.</b></p>
                <p><b>Jetzt 2 Monate gratis – exklusiv mit dem McDonald's Bonusprogramm!</b></p>
                <p>Deine Kinder mögen Hörspiele und Musik? Dann werden sie tigertones lieben! Morgens Tiere retten mit der Paw Patrol?
                    Am Mittag mit Bibi und Tina nach Schloss Falkenstein reiten? Und vor dem Schlafengehen Party
                    machen zu DIKKA und Heavysaurus? Mit tigertones kein Problem! tigertones begleitet dein Kind durch den ganzen
                    Tag und gibt dir die Sicherheit, dass die Inhalte wirklich zu ihm passen.</p>
                <p>Bei über 30.000 Hörspielen, Musikalben und Wissensinhalten hat Langeweile keine Chance.</p>
                <div>
                    <img alt="Beispiele Content" style={{margin: "1em 0"}} src={"https://cdn.tigerbooks.de/promotion/mcdonalds/mcdonalds_content.png"}/>
                </div>
                <p><b>Löse jetzt deinen McDonald’s Vorteilscode ein und teste tigertones 2 Monate lang kostenlos und unverbindlich.
                    Nach Ablauf der 2 Monate endet der Zugang automatisch. Eine Kündigung ist nicht notwendig.</b></p>
                <ul className="bullet-point-container">
                    <li>
                        Riesige Auswahl – alle Lieblingstitel, alle Folgen
                    </li>
                    <li>
                        Ohne Werbeunterbrechungen (ausgenommen Podcasts). Keine In-App-Käufe.
                    </li>
                    <li>
                        Für alle Altersgruppen geeignet – von 0 bis 14 Jahre
                    </li>
                    <li>
                        Endet automatisch – keine Kündigung nötig
                    </li>
                </ul>
                <p className={"mt-2"}><b>Mehr Spaß. Mehr Fantasie. Mehr Vielfalt.</b></p>
            </div>
            <div className="mcdonalds-form">
                <Form className="text-left" onSubmit={(e) => validateTicket(e)}>
                    {/* CODE */}
                    <Form.Group className={"voucher-code-input"} controlId="voucherCodeForm">
                        <Form.Control
                            type="text"
                            required
                            isInvalid={formError.voucherCode}
                            value={form.voucherCode}
                            onChange={e => updateForm('voucherCode', e.target.value)}
                            placeholder={Strings.MCDONALDS_REDEMPTION_CODE_PLACEHOLDER}
                        />

                        <Form.Control.Feedback type="invalid">
                            {formError.code}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <div className="button-container">
                        <TigerButton className="small-height" variant="blue" disabled={loading}>
                            {loading ?
                                <Spinner animation="border"/>
                                :
                                Strings.TICKET_REDEMPTION_SUBMIT_CREDENTIALS}
                        </TigerButton>
                    </div>
                </Form>
            </div>

            <p className={"mcdonalds-conditions"}>
                Das Angebot gilt vom 30.09. bis 27.10.2026 ausschließlich für Neukunden von tigertones. Als Neukunde gilt,
                wer aktuell keinen gültigen tigertones-Zugang besitzt und bisher noch keinen Testzeitraum genutzt hat.
                Pro Person ist nur eine Einlösung möglich. Nicht kombinierbar mit anderen tigertones-Angeboten oder bestehenden Abonnements.
            </p>

            <InfoModal
                title={Strings.REGISTER_UNKNOWN_ERROR_TITLE}
                text={errorText}
                show={showError}
                onHide={() => setShowError(false)}/>
        </div>
    )
}